import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.results');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-results',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.results/view.scss */
:host {
  display: block;
}

.results-page {
  width: min(100%, 1280px);
  margin: 0 auto;
  padding: 20px 24px 32px;
  color: #172033;
}

.results-header,
.results-status-tabs,
.results-toolbar,
.results-mobile-card,
.results-list {
  border: 1px solid #e2e8f0;
  background: #fff;
}

.results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 22px;
  border-radius: 16px;
}

.results-header h1 {
  margin: 0;
  color: #0f172a;
  font-size: 23px;
  font-weight: 780;
  letter-spacing: -0.025em;
}

.results-header p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 13px;
}

.results-header__count,
.results-progress {
  flex: 0 0 auto;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 12px;
  font-weight: 750;
}

.results-header__count {
  padding: 7px 11px;
}

.results-status-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  margin-top: 14px;
  padding: 6px;
  border-radius: 14px;
}

.results-status-tabs button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 9px;
  color: #64748b;
  font-size: 12px;
  font-weight: 720;
  transition: background 140ms ease, color 140ms ease, box-shadow 140ms ease;
}

.results-status-tabs button b {
  min-width: 23px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  line-height: 1.35;
}

.results-status-tabs button:hover:not(:disabled) {
  background: #f8fafc;
  color: #334155;
}

.results-status-tabs button.is-active {
  background: #eef2ff;
  color: #3730a3;
  box-shadow: inset 0 0 0 1px #c7d2fe;
}

.results-status-tabs button.is-active b {
  background: #fff;
  color: #4338ca;
}

.results-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-top: 14px;
  padding: 12px;
  border-radius: 14px;
}

.results-search {
  display: flex;
  flex: 1 1 auto;
  gap: 8px;
  min-width: 260px;
}

.results-search input,
.results-select-control select {
  min-height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #1e293b;
  font-size: 13px;
  outline: none;
}

.results-search input {
  width: 100%;
  padding: 0 12px;
}

.results-search input:focus,
.results-select-control select:focus {
  border-color: #818cf8;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.results-search button {
  min-width: 68px;
  min-height: 40px;
  border-radius: 9px;
  background: #3730a3;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}

.results-filter-controls {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.results-filter-field {
  display: grid;
  gap: 5px;
}

.results-filter-field > span {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.results-select-control {
  position: relative;
}

.results-select-control--form {
  width: 118px;
}

.results-select-control--status {
  width: 146px;
}

.results-select-control--sort {
  width: 172px;
}

.results-select-control::after {
  position: absolute;
  top: 50%;
  right: 13px;
  width: 7px;
  height: 7px;
  border-right: 1.5px solid #64748b;
  border-bottom: 1.5px solid #64748b;
  content: "";
  pointer-events: none;
  transform: translateY(-70%) rotate(45deg);
  transition: border-color 140ms ease;
}

.results-select-control:focus-within::after {
  border-color: #4f46e5;
}

.results-select-control select {
  width: 100%;
  min-width: 0;
  padding: 0 36px 0 11px;
  appearance: none;
  cursor: pointer;
}

.results-filter-reset {
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.results-filter-reset:hover:not(:disabled) {
  border-color: #a5b4fc;
  background: #f8faff;
  color: #4338ca;
}

.results-list {
  position: relative;
  min-height: 180px;
  margin-top: 14px;
  overflow: hidden;
  border-radius: 16px;
}

.results-list.is-loading {
  pointer-events: none;
}

.results-list.is-page-loading {
  pointer-events: none;
}

.results-loading {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.84);
  color: #64748b;
  font-size: 13px;
  font-weight: 650;
  backdrop-filter: blur(2px);
}

.results-page-progress {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  height: 3px;
  overflow: hidden;
  background: #eef2ff;
}

.results-page-progress span {
  display: block;
  width: 40%;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #818cf8, #4f46e5);
  animation: results-page-progress 0.9s ease-in-out infinite;
}

.results-spinner {
  width: 19px;
  height: 19px;
  border: 2px solid #c7d2fe;
  border-top-color: #4f46e5;
  border-radius: 999px;
  animation: results-spin 0.8s linear infinite;
}

.results-state {
  padding: 52px 20px;
  color: #94a3b8;
  font-size: 13px;
  text-align: center;
}

.results-state--error {
  margin-top: 14px;
  padding: 13px;
  border: 1px solid #fecdd3;
  border-radius: 12px;
  background: #fff1f2;
  color: #be123c;
}

.results-table-wrap {
  overflow-x: auto;
}

.results-table {
  width: 100%;
  min-width: 920px;
  border-collapse: collapse;
  font-size: 13px;
}

.results-table th {
  padding: 11px 14px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 750;
  text-align: left;
}

.results-table td {
  padding: 13px 14px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.results-table__row {
  cursor: pointer;
  transition: background 140ms ease;
}

.results-table__row:hover,
.results-table__row:focus,
.results-mobile-card:focus {
  background: #f8fafc;
  outline: none;
}

.results-mobile-card:focus {
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.14);
}

.results-table td strong,
.results-table td small,
.results-table td span {
  display: block;
}

.results-table td strong {
  color: #0f172a;
  font-weight: 720;
}

.results-table td small {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 11px;
}

.results-table__action {
  color: #4f46e5;
  font-size: 12px;
  font-weight: 750;
  text-align: right;
}

.results-form-status,
.results-mobile-card__forms button {
  border: 0;
  width: fit-content;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 720;
  cursor: pointer;
  transition: box-shadow 140ms ease, transform 140ms ease;
}

.results-form-status {
  display: block;
  padding: 5px 8px;
}

.results-form-status:hover,
.results-mobile-card__forms button:hover {
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.14);
  transform: translateY(-1px);
}

.is-pending {
  background: #f1f5f9;
  color: #64748b;
}

.is-in-progress {
  background: #fff7ed;
  color: #c2410c;
}

.is-admin-pending {
  background: #eef2ff;
  color: #4338ca;
}

.is-submitted {
  background: #ecfdf5;
  color: #047857;
}

.results-completed {
  color: #334155 !important;
  font-size: 12px;
}

.results-mobile-list {
  display: none;
}

.results-pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
}

.results-pagination button {
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.results-pagination button.is-active {
  border-color: #4f46e5;
  background: #4f46e5;
  color: #fff;
}

.results-pagination button:disabled,
.results-status-tabs button:disabled,
.results-search button:disabled,
.results-select-control select:disabled {
  cursor: wait;
  opacity: 0.55;
}

.results-filter-reset:disabled {
  cursor: default;
  opacity: 0.42;
}

.results-filter-reset.is-loading {
  cursor: wait;
}

@keyframes results-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes results-page-progress {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(250%);
  }
}
@media (max-width: 1100px) {
  .results-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .results-filter-controls {
    display: grid;
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1fr) minmax(0, 1fr) auto;
  }
  .results-select-control--form,
  .results-select-control--status,
  .results-select-control--sort {
    width: 100%;
  }
}
@media (max-width: 767px) {
  .results-page {
    padding: 16px 14px 28px;
  }
  .results-header {
    align-items: flex-start;
    padding: 17px;
  }
  .results-header h1 {
    font-size: 20px;
  }
  .results-status-tabs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .results-status-tabs button {
    justify-content: space-between;
    padding: 0 11px;
  }
  .results-filter-controls {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .results-filter-field:last-of-type {
    grid-column: 1/-1;
  }
  .results-filter-reset {
    grid-column: 1/-1;
  }
  .results-table-wrap {
    display: none;
  }
  .results-list {
    overflow: visible;
    border: 0;
    background: transparent;
  }
  .results-mobile-list {
    display: grid;
    gap: 10px;
  }
  .results-mobile-card {
    padding: 15px;
    border-radius: 14px;
    cursor: pointer;
  }
  .results-mobile-card__head,
  .results-mobile-card__foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .results-mobile-card__head strong,
  .results-mobile-card__head span {
    display: block;
  }
  .results-mobile-card__head strong {
    color: #0f172a;
    font-size: 14px;
  }
  .results-mobile-card__head div > span {
    margin-top: 2px;
    color: #94a3b8;
    font-size: 11px;
  }
  .results-progress {
    padding: 5px 8px;
  }
  .results-mobile-card__forms {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
    margin-top: 13px;
  }
  .results-mobile-card__forms button {
    width: 100%;
    padding: 7px 6px;
    text-align: center;
  }
  .results-mobile-card__forms i,
  .results-mobile-card__forms b {
    display: block;
    font-style: normal;
  }
  .results-mobile-card__forms i {
    font-size: 10px;
    opacity: 0.8;
  }
  .results-mobile-card__forms b {
    margin-top: 2px;
    font-size: 10px;
  }
  .results-mobile-card__foot {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid #f1f5f9;
    color: #94a3b8;
    font-size: 11px;
  }
  .results-mobile-card__foot strong {
    color: #4f46e5;
  }
}
/* Unified admin visual hierarchy */
.results-page {
  padding: 24px 28px 40px;
  color: var(--admin-text, #334155);
}

.results-header {
  padding: 2px 2px 6px;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.results-header h1 {
  color: var(--admin-text-strong, #111827);
  font-size: 24px;
  font-weight: 800;
}

.results-header p {
  color: var(--admin-text-muted, #64748b);
}

.results-header__count,
.results-progress {
  background: var(--admin-primary-soft, #eef2ff);
  color: var(--admin-primary-dark, #3730a3);
}

.results-status-tabs,
.results-toolbar,
.results-mobile-card,
.results-list {
  border-color: var(--admin-border, #dce2ea);
  background: var(--admin-surface, #fff);
}

.results-status-tabs,
.results-toolbar,
.results-list {
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.results-status-tabs button {
  color: var(--admin-text-muted, #64748b);
}

.results-status-tabs button.is-active {
  background: var(--admin-primary-soft, #eef2ff);
  box-shadow: inset 0 0 0 1px #c7d2fe;
  color: var(--admin-primary-dark, #3730a3);
}

.results-status-tabs button[data-status=complete].is-active {
  background: var(--admin-success-soft, #ecfdf5);
  box-shadow: inset 0 0 0 1px #a7f3d0;
  color: var(--admin-success, #047857);
}

.results-status-tabs button[data-status=partial].is-active {
  background: var(--admin-warning-soft, #fffbeb);
  box-shadow: inset 0 0 0 1px #fde68a;
  color: var(--admin-warning, #b45309);
}

.results-status-tabs button[data-status=none].is-active {
  background: var(--admin-surface-subtle, #f8fafc);
  box-shadow: inset 0 0 0 1px #cbd5e1;
  color: var(--admin-text, #334155);
}

.results-status-tabs button.is-active b {
  color: currentColor;
}

.results-toolbar {
  border-radius: 12px;
  background: linear-gradient(135deg, var(--admin-primary-soft, #eef2ff), rgba(255, 255, 255, 0) 34%), var(--admin-surface, #fff);
}

.results-search input,
.results-select-control select {
  border-color: #cbd5e1;
  background: var(--admin-surface, #fff);
  color: var(--admin-text-strong, #111827);
}

.results-search button {
  background: var(--admin-primary, #4f46e5);
}

.results-list {
  border-radius: 12px;
}

.results-table thead {
  background: var(--admin-surface-subtle, #f8fafc);
}

.results-table__row:hover {
  background: var(--admin-primary-soft, #eef2ff);
}

.results-table__action {
  color: var(--admin-primary, #4f46e5);
}

@media (max-width: 767px) {
  .results-page {
    padding: 16px 16px 32px;
  }
  .results-header {
    padding: 2px 0 14px;
  }
}`],
})
export class PageAdminResultsComponent implements OnInit {
    public rows: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 10;
    public q: string = '';
    public sortOption: string = 'latest_desc';
    public resultStatus: string = 'all';
    public formFilter: string = 'all';
    public formStatusFilter: string = 'all';
    public statusCounts: any = {
        all: 0,
        complete: 0,
        partial: 0,
        none: 0,
    };
    public statusOptions: any[] = [
        { key: 'all', label: '전체' },
        { key: 'complete', label: '전체 완료' },
        { key: 'partial', label: '일부 완료' },
        { key: 'none', label: '완료 결과 없음' },
    ];
    public formFilterOptions: any[] = [
        { key: 'all', label: '전체 양식' },
        { key: 'original_survey', label: 'CRF' },
        { key: 'geriatric_depression', label: 'SGDS-K' },
        { key: 'mmse', label: 'MMSE-K' },
    ];
    public formStatusOptions: any[] = [
        { key: 'all', label: '전체 상태' },
        { key: 'submitted', label: '완료' },
        { key: 'admin_pending', label: '관리자 기록 대기' },
        { key: 'in_progress', label: '작성 중' },
        { key: 'pending', label: '미작성' },
    ];
    public loading: boolean = false;
    public pageLoading: boolean = false;
    public errorMessage: string = '';
    private loadRequestId: number = 0;
    private pageRequestId: number = 0;
    private snapshotVersion: number = 0;
    private orderedIds: string[] = [];
    private pageCache: any = {};
    private pageRequests: any = {};
    private storageKey: string = 'reviewops.results.list-state.v1';

    constructor(@Inject( Service) public service: Service) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) return data.data;
        return data || {};
    }

    public async ngOnInit() {
        await this.service.init();
        this.restoreState();
        await this.load();
    }

    private allowed(options: any[], value: string, fallback: string): string {
        return options.some((option: any) => option.key === value)
            ? value
            : fallback;
    }

    private restoreState() {
        try {
            const raw = sessionStorage.getItem(this.storageKey);
            if (!raw) return;
            const state = JSON.parse(raw);
            this.q = String(state?.q || '');
            this.page = Math.max(1, Number(state?.page || 1));
            this.resultStatus = this.allowed(
                this.statusOptions,
                state?.resultStatus,
                'all',
            );
            this.formFilter = this.allowed(
                this.formFilterOptions,
                state?.formFilter,
                'all',
            );
            this.formStatusFilter = this.allowed(
                this.formStatusOptions,
                state?.formStatusFilter,
                'all',
            );
            const allowedSorts = [
                'latest_desc',
                'latest_asc',
                'completed_desc',
                'created_desc',
                'created_asc',
                'name_asc',
                'code_asc',
            ];
            this.sortOption = allowedSorts.includes(state?.sortOption)
                ? state.sortOption
                : 'latest_desc';
        } catch (e) {
            try {
                sessionStorage.removeItem(this.storageKey);
            } catch (storageError) {}
        }
    }

    private persistState() {
        try {
            sessionStorage.setItem(this.storageKey, JSON.stringify({
                q: this.q.trim(),
                page: this.page,
                resultStatus: this.resultStatus,
                formFilter: this.formFilter,
                formStatusFilter: this.formStatusFilter,
                sortOption: this.sortOption,
            }));
        } catch (e) {}
    }

    public async load() {
        const requestId = ++this.loadRequestId;
        const snapshotVersion = ++this.snapshotVersion;
        ++this.pageRequestId;
        this.loading = true;
        this.pageLoading = false;
        this.errorMessage = '';
        this.orderedIds = [];
        this.pageCache = {};
        this.pageRequests = {};
        this.persistState();
        await this.service.render();

        const params: any = {
            page: this.page,
            dump: this.dump,
            sort: this.sortOption,
            status: this.resultStatus,
            form_code: this.formFilter,
            form_status: this.formStatusFilter,
        };
        if (this.q.trim()) params.q = this.q.trim();

        const { code, data } = await wiz.call('list', params);
        if (requestId !== this.loadRequestId) return;

        this.loading = false;
        if (code === 200) {
            const payload = this.payload(data);
            this.rows = payload.rows || [];
            this.total = Number(payload.total || 0);
            this.page = Number(payload.page || 1);
            this.orderedIds = (payload.ordered_ids || []).map(
                (value: any) => String(value),
            );
            this.cachePage(this.page, this.rows, snapshotVersion);
            this.resultStatus = payload.status || this.resultStatus;
            this.formFilter = payload.form_code || this.formFilter;
            this.formStatusFilter = (
                payload.form_status
                || this.formStatusFilter
            );
            this.sortOption = payload.sort || this.sortOption;
            this.statusCounts = payload.status_counts || this.statusCounts;
            this.persistState();
        } else {
            this.rows = [];
            this.total = 0;
            this.errorMessage = (
                (data && data.message)
                || '결과 목록을 불러오지 못했습니다.'
            );
        }
        await this.service.render();
        if (code === 200) {
            this.prefetchAdjacentPages(this.page, snapshotVersion);
        }
    }

    public async search() {
        this.page = 1;
        await this.load();
    }

    public async setSort(value: string) {
        const allowed = [
            'latest_desc',
            'latest_asc',
            'completed_desc',
            'created_desc',
            'created_asc',
            'name_asc',
            'code_asc',
        ];
        this.sortOption = allowed.includes(value)
            ? value
            : 'latest_desc';
        this.page = 1;
        await this.load();
    }

    public async setResultStatus(value: string) {
        const allowed = this.statusOptions.map(
            (option: any) => option.key,
        );
        this.resultStatus = allowed.includes(value) ? value : 'all';
        this.page = 1;
        await this.load();
    }

    public async setFormFilter(value: string) {
        this.formFilter = this.allowed(
            this.formFilterOptions,
            value,
            'all',
        );
        this.page = 1;
        await this.load();
    }

    public async setFormStatusFilter(value: string) {
        this.formStatusFilter = this.allowed(
            this.formStatusOptions,
            value,
            'all',
        );
        this.page = 1;
        await this.load();
    }

    public hasActiveFilters(): boolean {
        return (
            !!this.q.trim()
            || this.resultStatus !== 'all'
            || this.formFilter !== 'all'
            || this.formStatusFilter !== 'all'
            || this.sortOption !== 'latest_desc'
        );
    }

    public async resetFilters() {
        this.q = '';
        this.page = 1;
        this.resultStatus = 'all';
        this.formFilter = 'all';
        this.formStatusFilter = 'all';
        this.sortOption = 'latest_desc';
        await this.load();
    }

    public statusCount(key: string): number {
        return Number(this.statusCounts?.[key] || 0);
    }

    public emptyMessage(): string {
        if (this.q.trim()) return '검색 조건에 맞는 대상자가 없습니다.';
        if (this.resultStatus !== 'all') {
            return '해당 완료 상태의 대상자가 없습니다.';
        }
        return '대상자가 없습니다.';
    }

    public formByCode(row: any, code: string): any {
        return (row?.forms || []).find(
            (form: any) => form?.code === code,
        ) || { code, status: 'pending', overall_status: 'pending' };
    }

    public formStatus(form: any): string {
        return (
            form?.overall_status
            || form?.status
            || 'pending'
        );
    }

    public formStatusLabel(form: any): string {
        const labels: any = {
            pending: '미작성',
            in_progress: '작성 중',
            admin_pending: '관리자 기록 대기',
            submitted: '완료',
        };
        return labels[this.formStatus(form)] || '미작성';
    }

    public formStatusClass(form: any): string {
        return 'is-' + this.formStatus(form).replace('_', '-');
    }

    public async filterByFormStatus(
        event: Event,
        formCode: string,
        form: any,
    ) {
        event.stopPropagation();
        this.formFilter = formCode;
        this.formStatusFilter = this.formStatus(form);
        this.resultStatus = 'all';
        this.page = 1;
        await this.load();
    }

    public resultCountLabel(row: any): string {
        return `${Number(row?.completed_forms || 0)} / 3 완료`;
    }

    public genderLabel(value: string): string {
        if (value === 'M') return '남';
        if (value === 'F') return '여';
        return '-';
    }

    public formatDate(value: any): string {
        if (!value) return '-';
        return String(value).slice(0, 10);
    }

    public totalPages(): number {
        return Math.max(1, Math.ceil(this.total / this.dump));
    }

    public pageList(): number[] {
        const pages = this.totalPages();
        const visiblePages = 5;
        const start = Math.max(
            1,
            Math.min(
                this.page - Math.floor(visiblePages / 2),
                pages - visiblePages + 1,
            ),
        );
        const end = Math.min(pages, start + visiblePages - 1);
        const result: number[] = [];
        for (let value = start; value <= end; value++) {
            result.push(value);
        }
        return result;
    }

    public async setPage(page: number) {
        if (
            page < 1
            || page > this.totalPages()
            || page === this.page
            || this.loading
        ) return;

        const snapshotVersion = this.snapshotVersion;
        const requestId = ++this.pageRequestId;
        const cached = this.cachedPage(page);
        const previousPage = this.page;
        this.page = page;
        this.errorMessage = '';
        this.persistState();

        if (cached !== null) {
            this.pageLoading = false;
            this.rows = cached;
            await this.service.render();
            this.prefetchAdjacentPages(page, snapshotVersion);
            return;
        }

        this.pageLoading = true;
        await this.service.render();
        const rows = await this.fetchPage(page, snapshotVersion);
        if (
            requestId !== this.pageRequestId
            || snapshotVersion !== this.snapshotVersion
        ) return;

        this.pageLoading = false;
        if (rows === null) {
            this.page = previousPage;
            this.persistState();
            this.errorMessage = '페이지를 불러오지 못했습니다. 다시 시도해 주세요.';
        } else {
            this.rows = rows;
        }
        await this.service.render();
        if (rows !== null) {
            this.prefetchAdjacentPages(page, snapshotVersion);
        }
    }

    private cachePage(page: number, rows: any[], version: number) {
        if (version !== this.snapshotVersion) return;
        this.pageCache[String(page)] = rows || [];
    }

    private cachedPage(page: number): any[] | null {
        const key = String(page);
        if (!Object.prototype.hasOwnProperty.call(this.pageCache, key)) {
            return null;
        }
        return this.pageCache[key] || [];
    }

    private pageIds(page: number): string[] {
        const start = (page - 1) * this.dump;
        return this.orderedIds.slice(start, start + this.dump);
    }

    private async requestPage(page: number): Promise<any[] | null> {
        const ids = this.pageIds(page);
        if (ids.length === 0) return [];
        try {
            const { code, data } = await wiz.call('page_rows', {
                ids: JSON.stringify(ids),
            });
            if (code !== 200) return null;
            const payload = this.payload(data);
            return payload.rows || [];
        } catch (e) {
            return null;
        }
    }

    private async fetchPage(
        page: number,
        version: number,
    ): Promise<any[] | null> {
        if (version !== this.snapshotVersion) return null;
        const cached = this.cachedPage(page);
        if (cached !== null) return cached;

        const key = `${version}:${page}`;
        if (!this.pageRequests[key]) {
            this.pageRequests[key] = this.requestPage(page);
        }
        const request = this.pageRequests[key];
        let rows: any[] | null = null;
        try {
            rows = await request;
        } finally {
            if (this.pageRequests[key] === request) {
                delete this.pageRequests[key];
            }
        }
        if (rows !== null) {
            this.cachePage(page, rows, version);
        }
        return rows;
    }

    private prefetchAdjacentPages(page: number, version: number) {
        for (const value of [page - 1, page + 1]) {
            if (value < 1 || value > this.totalPages()) continue;
            this.prefetchPage(value, version);
        }
    }

    private async prefetchPage(page: number, version: number) {
        if (
            version !== this.snapshotVersion
            || this.cachedPage(page) !== null
        ) return;
        await this.fetchPage(page, version);
    }

    public open(row: any) {
        if (!row?.id) return;
        this.persistState();
        this.service.href('/admin/results/' + row.id);
    }

    public openFromKeyboard(event: KeyboardEvent, row: any) {
        if (event.target !== event.currentTarget) return;
        this.open(row);
    }
}

export default PageAdminResultsComponent;